<script>
import LandingPageMixin from '@/mixins/landingpage'

// isMenuToggle: toggleMenu()
// isModalToggle: toggleModal()
// showCover: toggleCover()

export default {
  name: 'LandingPageTtcGroups',
  mixins: [ LandingPageMixin ],
  computed: {},
  data () {
    return {
      isModalTermsAndConditionsToggle: false,
      isModalWhoWeAreVideoToggle: false,
      isModalTravelStylesVideoToggle: false,
      isModalTreadrightVideoToggle: false
    }
  },
  methods: {
    toggleTermsAndConditionsModal () {
      this.isModalTermsAndConditionsToggle = !this.isModalTermsAndConditionsToggle
      document.body.classList.toggle('modal-open', this.isModalTermsAndConditionsToggle)
    },
    toggleWhoWeAreVideoModal () {
      this.isModalWhoWeAreVideoToggle = !this.isModalWhoWeAreVideoToggle
      document.body.classList.toggle('modal-open', this.isModalWhoWeAreVideoToggle)
    },
    toggleTravelStylesVideoModal () {
      this.isModalTravelStylesVideoToggle = !this.isModalTravelStylesVideoToggle
      document.body.classList.toggle('modal-open', this.isModalTravelStylesVideoToggle)
    },
    toggleTreadrightVideoModal () {
      this.isModalTreadrightVideoToggle = !this.isModalTreadrightVideoToggle
      document.body.classList.toggle('modal-open', this.isModalTreadrightVideoToggle)
    },
    scrollMeTo (refName) {
      var element = document.getElementById(refName)
      window.scrollTo({
        top: element.offsetTop - 80,
        behavior: 'smooth'
      })
    },
    scrollMeDay (dd) {
      var element = document.getElementById(dd)
      var modal = document.getElementById('modal-fullscreen')
      modal.scrollTo({
        top: element.offsetTop,
        behavior: 'smooth'
      })
    }
  }
}

</script>

<style lang="scss" scoped>
@import './font-fontawesome.scss';
@import './bootstrap.scss';
@import './main.scss';
@import './style-1.scss';
</style>
<template>
  <div id="menu" class="body-page fp-viewing-home body" :class="{ 'modal-open': isModalToggle }">
    <!-- BEGIN OF site header Menu -->
    <header class="page-header navbar page-header-drawer menu-right logo-left topmenu-right animated slow fadeIn">

      <!-- Begin of menu icon toggler -->
      <button class="navbar-toggler site-menu-icon" id="navMenuIcon" :class="{ 'menu-visible': isMenuToggle }" @click="toggleMenu" >
        <span class="menu-icon menu-icon-line" :class="{ 'menu-visible': isMenuToggle }">
          <span class="bars">
            <span class="bar1"></span>
            <span class="bar2"></span>
            <span class="bar3"></span>
          </span>
        </span>
      </button>

      <div class="cover-title" v-show="!showCover">
        <div class="cover-logo">
          <a class="navbar-brand" href="#">
            <span class="logo">
              <img class="light-logo" src="/landingpages/ttc-groups/img/logo.png" alt="Logo">
            </span>
          </a>
        </div>
      </div>

      <div class="all-menu-wrapper" id="navbarMenu" :class="{ 'menu-visible': isMenuToggle }">
        <nav class="navbar-mainmenu">
          <div class="mainmenu-bg" @click="toggleMenu"></div>
          <div class="mainmenu-content">
          <img src="/landingpages/ttc-groups/img/logo.png" alt="Logo" class="light-logo menu-logo">
          <div class="divider-menu">
          </div>
            <ul class="navbar-nav">
              <li class="nav-item active">
                <a class="nav-link" href="#home" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('home')">Home
                  <span class="sr-only">(current)</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#map" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('map')">Map</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#itinerary" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('itinerary')">Itinerary</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#prices" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('prices')">Pricing</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#highlight" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('highlight')">Highlights</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#contact" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('contact')">Contact Us</a>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </header>
    <!-- END OF site header Menu-->

    <!-- BEGIN OF page main content -->
    <main class="page-main main-anim scrollpage-container animated fadeIn" id="mainpage">
      <div
        id="home"
        class="backgroundHome section section-home fullscreen-md main-home section-center content-black bg-level-1"
        data-section="home"
        :style="[ firstOpporunityBackgroundImage != ''
                  ? {
                    backgroundImage: `url('${getParsedImageUrl(
                      firstOpporunityBackgroundImage
                    )}')`
                  } : { backgroundImage: 'url(/landingpages/ttc-groups/img/bg-style-1.jpg)'}]">
        <div class="overlay-home"></div>
        <div class="section-wrapper animated delay-1s slow fadeIn home-flex">
          <div class="section-content anim">
            <div class="row">
              <div class="col-12 col-md-12 text-left">
                <div class="cover-header-description text-center" >
                  <div class="location" v-if="Array.isArray(d.itineraries.locations_visited) == true">
                    <i class="fa fa-map-marker" ></i>
                    <span v-if="d && d.itineraries && d.itineraries.locations_visited && Array.isArray(d.itineraries.locations_visited)">{{ d.itineraries.locations_visited | custom-join('name') }}</span>
                  </div>
                  <div class="cover-slider-description">
                    <h1 class="cover-header-description-title1">
                      <i class="icon fa fa-calendar"></i>
                      <span class="text-uppercase" v-if="d && d.itineraries">{{ d.itineraries.fromitinerary | custom-date }}</span>
                      <i class="fa fa-arrow-right ml-2"></i>
                      <i class="icon fa fa-calendar"></i>
                      <span class="text-uppercase" v-if="d && d.itineraries">{{ d.itineraries.toitinerary | custom-date }}</span>
                    </h1>
                    <div class="cover-header-description-title2" v-if="d && d.consumer_section">
                      {{ d.consumer_section.trip_name }}
                    </div>
                    <div class="cover-header-description-title3" v-if="d && d.consumer_section">
                        <span>{{ d.consumer_section.trip_subtitle }}</span>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <footer class="section-footer scrolldown" >
            <a class="down" @click="scrollMeTo('description')">
              <span class="icon"></span>
              <span class="txt">DESCRIPTION</span>
            </a>
          </footer>
        </div>
      </div>

      <!-- Begin of grid list section -->
      <div class="section fl-porto bg-level-1" data-section="description" id="description" >
        <div class="section-wrapper with-margin">
          <div class="row">
            <div class="col-12 col-md-12">
              <div class="section-tittle text-center">
                <img class="ttcimage" src="/landingpages/ttc-groups/img/ttc_welcome.jpg">
                <div class="ttcwelcome">WELCOME TO <span>TTC</span></div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-12 text-left ">
              <!-- title and description -->
              <div
                class="title-desc anim-4 paddig-container letter-information"
                 v-html="d.consumer_section.short_description">
              </div>
               <div class="tour_host_box paddig-container" v-if="d.consumer_section.tour_host_photo">
                  <img class="tour_host_photo" :src="d.consumer_section.tour_host_photo"/>
                  <div class="tour_host_info">
                    <p class="tour_host_name" v-if="d.consumer_section.tour_host_name" v-html="d.consumer_section.tour_host_name"></p>
                    <p v-if="d.consumer_section.tour_host_position" v-html="d.consumer_section.tour_host_position"></p>
                  </div>
                </div>
                <span class="tour_host_box" v-if="!d.consumer_section.tour_host_photo"></span>
            </div>
          </div>
        </div>
      </div>
      <!-- End of grid list section -->

      <!-- Begin of grid list section -->
      <div class="section bg-level-2" data-section="itinerary" id="itinerary" >
        <div class="section-wrapper with-margin">
          <div class="section-content anim paddig-container">
            <div class="section-tittle text-center">
              <div class="cover-header-description-title2 title-sections scrolled">Itinerary</div>
              <div class="cover-header-description-title3" v-if="d && d.consumer_section">
                {{ d.consumer_section.trip_name }}
              </div>
              <div class="cover-header-description-title4">
                <i class="icon fa fa-calendar"></i>
                <span class="text-uppercase" v-if="d && d.itineraries">{{ d.itineraries.fromitinerary | custom-date }}</span>
                <i class="fa fa-arrow-right"></i>
                <i class="icon fa fa-calendar"></i>
                <span class="text-uppercase" v-if="d && d.itineraries">{{ d.itineraries.toitinerary | custom-date }}</span>
                <i v-if="d && d.itineraries && d.itineraries.locations_visited && Array.isArray(d.itineraries.locations_visited)" class="fa fa-map-marker"></i>
                <span v-if="d && d.itineraries && d.itineraries.locations_visited && Array.isArray(d.itineraries.locations_visited)">{{ d.itineraries.locations_visited | custom-join('name') }}</span>
              </div>
            </div>
            <div class="row row-random grid-media-aside-text fade-3">

                <div class="col-md-4 border-card" v-for="(day, index) in d.itineraries.days" :key="index" @click="dayScrollTo(index)">
                  <div class="card gallery-day" data-toggle="modal" data-target="#modal-fullscreen">
                    <img v-if="day.url_image_1200_725" :src="day.url_image_1200_725"/>
                    <img v-if="!day.url_image_1200_725" src="/landingpages/ttc-groups/img/day-img.jpg"/>
                    <div class="info text-center">
                      <p class="day_position">day {{ day.startday }}</p>
                      <h1 class="title-day" v-html="day.title"></h1>
                      <p>
                        <i class="icon fa fa-calendar mr-2"></i>
                        <span class="text-uppercase" v-if="day">{{ day.startdate | custom-date }}</span>
                      </p>
                      <p v-if="day && day.locations && Array.isArray(day.locations)" class="location mt-2">
                        <i class="fa fa-map-marker mr-2"></i>
                        <span >{{ day.locations | custom-join('name') }}</span>
                      </p>
                    </div>
                  </div>
                </div>

            </div>
          </div>
        </div>
      </div>
      <!-- End of grid list section -->
       <!-- Begin of description section -->
      <div class="section fullscreen-md-off bg-level-3 bg-fixed" data-section="highlight" id="highlight"
        :style="[ secondOpporunityBackgroundImage != ''
                  ? {
                    backgroundImage: `url('${getParsedImageUrl(
                      secondOpporunityBackgroundImage
                    )}')`
                  } : { backgroundImage: 'url(/landingpages/ttc-groups/img/bg-style-1.jpg)'}]"
        v-if="Array.isArray(d.consumer_section.highlights) && d.consumer_section.highlights.length > 0 ||
        Array.isArray(d.consumer_section.whatsincluded) && d.consumer_section.whatsincluded.length > 0">
        <div class="section-wrapper with-margin bg-overlay">
          <div class="section-content anim paddig-container">
            <div class="row">
              <div class="col-12 col-md-12 text-left">
                  <div class="section-info white" v-if="Array.isArray(d.consumer_section.highlights) && d.consumer_section.highlights.length > 0">
                    <h1 class="title-sections title-sections-blue">Highlights</h1>
                      <div v-for="highlight in d.consumer_section.highlights" :key="highlight.id">
                        <h3 class="hideInclusionTitle" v-html="highlight.title"></h3>
                        <ul class="mb-4 mt-4">
                          <li v-for="item in highlight.items" :key="item.id" v-html="item.items"></li>
                        </ul>
                      </div>
                  </div>
                  <div class="section-info light-blue  pr-4" v-if="Array.isArray(d.consumer_section.whatsincluded) && d.consumer_section.whatsincluded.length > 0">
                    <h1 class="title-sections title-sections-blue">What's Included</h1>
                    <div v-for="whatsinc in d.consumer_section.whatsincluded" :key="whatsinc.id">
                      <h3 class="hideInclusionTitle"  v-html="whatsinc.title"></h3>
                      <ul class="mb-4 mt-4">
                        <li v-for="item in whatsinc.items" :key="item.id" v-html="item.items"></li>
                      </ul>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Begin of description section -->
      <div class="section section-register bg-level-1" data-section="map" id="map" >
        <div class="section-wrapper with-margin pb-0">
          <div class="section-content anim paddig-container">
            <div class="row">
              <div class="col-12 col-md-12 text-center">
                <div class="title-desc">
                  <h2 class="title-sections-blue title-sections">Map</h2>
                  <p class="mb-5 mt-3">Map route is to be used as a guide for illustration purposes only, and does not represent the exact path taken.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
         <div class="col-12 col-md-12 p0">
          <div class="section-maps">
            <Map :locations="locationsVisited" />
          </div>
        </div>
      </div>
      <!-- Begin of description section -->
      <div class="section fullscreen-md-off bg-level-2 no-footer " data-section="prices" id="prices" >
        <div class="section-wrapper with-margin">
          <div class="section-content anim paddig-container">
            <div class="row">
              <div class="col-12 col-md-12 text-left">
                <div class="title-desc">
                  <h2 class="display-5 anim-2 title-sections content-white">Pricing</h2>
                </div>
                <div class="section-info white table_pricing">
                  <div class="row">
                    <div class="col-12 col-md-6 anim">
                      <div class="title-desc amount-price" v-if="d && d.consumer_section">
                        <p class="display-5 anim-2">Twin Share Price</p>
                        <h2 class="display-5 anim-2 text-center pb-0">{{ d.consumer_section.twinshare_price }}</h2>
                      </div>
                    </div>
                    <div class="col-12 col-md-6 anim fluid contact-info-right">
                      <div class="contact-us-box">
                        <div class="title-desc amount-price" v-if="d && d.consumer_section">
                          <p class="display-5 anim-2">Single Supplement Price</p>
                          <h2 class="display-5 anim-2 text-center pb-0">{{ d.consumer_section.single_supp_price }}</h2>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <p class="terms">View <a href="#" @click.prevent="toggleTermsAndConditionsModal">Terms and Conditions</a></p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section fullscreen-md-off bg-level-1 no-footer " data-section="about" id="about" >
        <div class="section-wrapper">
          <div>
            <div class="row">
              <div class="col-12 col-md-4 p0">
                  <div class="card gallery-day justify-content-center card-about" @click.prevent="toggleWhoWeAreVideoModal">
                    <div class="info-about">
                      <img src="/landingpages/ttc-groups/img/whoweare.jpg"/>
                      <div class="info text-center">
                        <h1 class="title-day text-center">WHO WE ARE</h1>
                        <button type="button" class="button button-play button-play-about"></button>
                      </div>
                    </div>
                  </div>
              </div>
              <div class="col-12 col-md-4 p0">
                  <div class="card gallery-day justify-content-center card-about" @click.prevent="toggleTravelStylesVideoModal">
                    <div class="info-about">
                      <img src="/landingpages/ttc-groups/img/travelstyles.jpg"/>
                      <div class="info text-center">
                        <h1 class="title-day text-center">TRAVEL STYLES</h1>
                        <button type="button" class="button button-play button-play-about"></button>
                      </div>
                    </div>
                  </div>
              </div>
              <div class="col-12 col-md-4 p0">
                  <div class="card gallery-day justify-content-center card-about" @click.prevent="toggleTreadrightVideoModal">
                    <div class="info-about">
                      <img src="/landingpages/ttc-groups/img/treadright.jpg"/>
                      <div class="info text-center">
                        <h1 class="title-day text-center">TREADRIGHT</h1>
                        <button type="button" class="button button-play button-play-about"></button>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Begin of contact section -->
      <div class="section section-contact bg-level-1 bg-mark " data-section="contact" id="contact"  >
        <img v-if="thirdOpporunityBackgroundImage != ''" :src="`${thirdOpporunityBackgroundImage}`" alt="">
        <img v-else src="/landingpages/ttc-groups/img/bg-style-1.jpg" alt="">

        <div class="section-wrapper with-margin">
          <div class="section-content paddig-container">
            <div class="row">
              <div class="col-12 col-md-6 anim contact-info contact-info-left ">
                <div class="title-desc">
                  <h2 class="title-sections-blue text-center title-sections">Contact us</h2>
                </div>
                 <div class="pt-4 text-center">
                   <h3 class="pt-4" v-if="!d.consumer_section && !d.consumer_section.company_logo">
                      Contact your Travel Agent!
                   </h3>

                    <p class="pt-4 pb-4 text-center" v-if="!d.consumer_section.call_action">
                      Please send us a message. We will answer your questions with pleasure.
                    </p>

                    <p class="contact-info-call" v-if="d.consumer_section.call_action" v-html="d.consumer_section.call_action"></p>
                    <img class="tour_host_logo" v-if="d.consumer_section.company_logo" :src="d.consumer_section.company_logo"/>
                 </div>
              </div>

              <div class="col-12 col-md-6 anim contact-info contact-info-right fluid contact-border-left">
                  <div class="title-desc">
                    <h2 class="title-sections-blue text-center title-sections">Message Us Directly</h2>
                  </div>
                <div class="contact-us-box">
                  <form  class="form-box" @submit.prevent="sendContactForm">
                    <div class="form-group ">
                      <input class="form-control-white" type="text" required placeholder="Your Name" v-model="name" :disabled="isSending">
                    </div>
                    <div class="form-group ">
                      <input class="form-control-white" type="text" required placeholder="Your Email" v-model="email" :disabled="isSending">
                    </div>
                    <div class="form-group ">
                      <textarea class="form-control-white" type="text" required placeholder="How can we assist you with this group?" cols="10" rows="10" v-model="description" :disabled="isSending"></textarea>
                    </div>
                    <div class="form-group form-success-gone text-right mb-0 d-flex justify-content-center align-items-center">
                      <div v-if="isCompleted">{{ message }}</div>
                      <button class="btn btn-radius btn-blue" type="submit" :disabled="isSending">
                        <span class="text" v-if="!isSending">Send</span>
                        <span class="text" v-else>Sending</span>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <footer >
        <div class="section-wrapper padding-footer ">
          <div class="powered-by-text">
            Powered by<br>
            <img src="/landingpages/ttc-groups/img/logo-itp.png" width="80">
          </div>
          <div class="detail">All rights reserved: ©Global Encounters™ 1999 - {{new Date().getFullYear()}}</div>
        </div>
      </footer>

    </main>
    <!-- Modal Fullscreen -- WHO WE ARE -->
      <div
        class="modal modal-fullscreenTC fade"
        id="modal-who-we-are" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
        :class="{ 'show': isModalWhoWeAreVideoToggle }"
        :style="{ display: 'block', paddingRight: '16px' }"
        v-show="isModalWhoWeAreVideoToggle">
        <div class="section-header">
          <button
            type="button" class="close" data-dismiss="modal" aria-hidden="true"
            @click="toggleWhoWeAreVideoModal"><i class="fa fa-times"></i></button>
        </div>
        <div class="modal-dialog animated fadeIn">
          <div class="modal-content modal-video-content">
            <div class="modal-body">
              <div
                class="video-modal">
                <iframe width="100%" height="100%" src="https://www.youtube.com/embed/l-srUJ1GQXU" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    <!-- Modal Fullscreen -- TRAVEL STYLES -->
      <div
        class="modal modal-fullscreenTC fade"
        id="modal-travel-styles" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
        :class="{ 'show': isModalTravelStylesVideoToggle }"
        :style="{ display: 'block', paddingRight: '16px' }"
        v-show="isModalTravelStylesVideoToggle">
        <div class="section-header">
          <button
            type="button" class="close" data-dismiss="modal" aria-hidden="true"
            @click="toggleTravelStylesVideoModal"><i class="fa fa-times"></i></button>
        </div>
        <div class="modal-dialog animated fadeIn">
          <div class="modal-content modal-video-content">
            <div class="modal-body">
              <div
                class="video-modal">
                <iframe width="100%" height="100%" src="https://www.youtube.com/embed/X7t9tZXgWO4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    <!-- Modal Fullscreen -- TREADRIGHT -->
      <div
        class="modal modal-fullscreenTC fade"
        id="modal-treadright" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
        :class="{ 'show': isModalTreadrightVideoToggle }"
        :style="{ display: 'block', paddingRight: '16px' }"
        v-show="isModalTreadrightVideoToggle">
        <div class="section-header">
          <button
            type="button" class="close" data-dismiss="modal" aria-hidden="true"
            @click="toggleTreadrightVideoModal"><i class="fa fa-times"></i></button>
        </div>
        <div class="modal-dialog animated fadeIn">
          <div class="modal-content modal-video-content">
            <div class="modal-body">
              <div
                class="video-modal">
                <iframe width="100%" height="100%" src="https://www.youtube.com/embed/tJDwHFOIXDs" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    <!-- Modal Fullscreen -- TERMS AND CONDITIONS -->
      <div
        class="modal modal-fullscreenTC fade"
        id="modal-terms-and-conditions-fullscreen" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
        :class="{ 'show': isModalTermsAndConditionsToggle }"
        :style="{ display: 'block', paddingRight: '16px' }"
        v-show="isModalTermsAndConditionsToggle">
        <div class="section-header">
          <button
            type="button" class="close" data-dismiss="modal" aria-hidden="true"
            @click="toggleTermsAndConditionsModal"><i class="fa fa-times"></i></button>
        </div>
        <div class="modal-dialog animated fadeIn">
          <div class="modal-content  ">
            <div class="modal-body">
              <div class="title-desc "><h3 class="h2 title-sections-2 title-sections-blue pt-3">Terms & Conditions</h3></div>
              <div
                class="title-desc anim-4 paddig-container scrollable terms-information"
                v-html="d.consumer_section.terms_conditions">
              </div>
            </div>
          </div>
        </div>
      </div>

    <!-- Modal Fullscreen -- DAYS-->
    <div
      class="modal modal-fullscreen fade modalDays animated fadeIn"
      id="modal-fullscreen" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
      :class="{ 'show': isModalToggle }"
      :style="{ display: 'block', paddingRight: '16px' }"
      v-show="isModalToggle">
      <div class="section-header">
        <img class="light-logo" src="/landingpages/ttc-groups/img/logo.png" alt="Logo">
        <button
          type="button" class="close" data-dismiss="modal" aria-hidden="true"
          @click="toggleModal"><i class="fa fa-times"></i></button>
      </div>
      <div class="modal-dialog ">
        <div class="modal-content  ">
          <div class="modal-body">

            <div
              class="col-md-12 p-0 section-day p active"
              :id="`day${index}`"
              v-for="(day, index) in d.itineraries.days" :key="index">
              <div class="row">
                <div class="col-md-6 cover-image">
                  <img v-if="day.url_image_1600_900" :src="day.url_image_1600_900"/>
                  <img v-if="!day.url_image_1600_900" src="/landingpages/ttc-groups/img/day-img.jpg"/>
                </div>
                <div class="col-md-6 section-text pl-0">
                  <div class="align-vcenter text-center">
                    <h1>Day {{ index + 1}}</h1>
                    <p class="subtittle" v-html="day.title"></p>
                    <p class="date text-uppercase title-sections-blue fw-500">
                      <i class="icon fa fa-calendar mr-1"></i>
                      <span v-if="day">{{ day.startdate | custom-date }}</span>
                    </p>
                    <p class="location mt-2 text-uppercase title-sections-blue fw-500" v-if="day && day.locations && Array.isArray(day.locations)" >
                      <i class="fa fa-map-marker mr-2"></i>
                      <span>{{ day.locations | custom-join('name') }}</span>
                    </p>
                    <p class="day-information" v-if="day && day.textday && day.textday[0] && day.textday[0].textday" v-html="day.textday[0].textday"></p>
                    <p v-if="day.meals">
                      <strong class="mr-1">MEAL(S):</strong>
                      <span>{{ day.meals | custom-join('mealsday') }}</span>
                    </p>
                    <p v-if="day.accommodation">
                      <strong class="mr-1">ACCOMMODATION:</strong>
                      <span v-html="day.accommodation"></span>
                    </p>
                  </div>
                  <footer class="section-footer scrolldownDay nextday"
                  v-if="index != Object.keys(d.itineraries.days).length - 1">
                    <a class="down" @click="scrollMeDay(`day${index+1}`)">
                      <span class="txt">DAY {{ Number(day.startday) + 1 }}</span>
                    </a>
                  </footer>
                  <footer class="section-footer scrolldownDay nextday" v-else>
                    <a class="down" @click="scrollMeDay('day0')">
                      <span class="txt">DAY 1</span>
                    </a>
                  </footer>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>
